import PropTypes from 'prop-types';
import { oneOfTypes, orderConfigsPropTypes } from 'common/propTypes';
import HoverMessage from 'common/components/HoverMessage';
import HtmlParser from 'react-html-parser';
import PlaceStoplossOrderToBrokerFieldSelector from './PlaceStoplossOrderToBrokerFieldSelector';
import { isIndividualStoplossAvailable } from '../ProfitAndOrdersComponents/helper';
import ApplicationDomainUtility from 'v3/common/utils/applicationDomain';

const propTypes = {
  isPlaceStoplossOrderToBroker: oneOfTypes,
  handleChange: PropTypes.func.isRequired,
  orderConfigs: orderConfigsPropTypes
};
const defaultProps = { isPlaceStoplossOrderToBroker: '', orderConfigs: [] };

const PlaceStoplossOrderToBrokerField = ({
  isPlaceStoplossOrderToBroker, handleChange, orderConfigs
}) => {
  if (!isIndividualStoplossAvailable(orderConfigs)) { return null; }
  const oneIndentation = ' ';

  let content = `<b>If yes,</b></br>${ApplicationDomainUtility.partnerName} will place individual `;
  content += 'leg stoploss(SL-Limit) order to broker and as well as we also track the stoploss order.';
  content += '</br></br><b>If No,</b></br>';
  content += `${ApplicationDomainUtility.partnerName} will track your stoploss and close position if stoploss acheived. `;
  content += '<b>No SL-Limit order to broker<b>';

  return (
    <div className="row mb-1">
      <label className="col-md-3 place-orders-label">
        Should Place individual leg stoploss(sl-l) order to broker?
        {oneIndentation}
        <HoverMessage
          title=""
          message={HtmlParser(content)}
        >
          <span className="material-icons-outlined text-muted tx-16 align-middle">
            info
          </span>
        </HoverMessage>
        {oneIndentation}
      </label>
      <div className="col-md-9 place-options">
        <PlaceStoplossOrderToBrokerFieldSelector
          optionType={isPlaceStoplossOrderToBroker}
          onOptionTypeChange={(value) => {
            handleChange(value);
          }}
        />
      </div>
    </div>
  );
};

PlaceStoplossOrderToBrokerField.propTypes = propTypes;
PlaceStoplossOrderToBrokerField.defaultProps = defaultProps;

export default PlaceStoplossOrderToBrokerField;
